export const FETCH_DASHBOARD_SESSION_COUNT = 'FETCH_DASHBOARD_SESSION_COUNT'
export const FETCH_RATINGS_SUMMARY = 'FETCH_RATINGS_SUMMARY'
